import React from "react";
import UploadFileTabPanel from "../../components/mosaic/Home/UploadFileTabPanel";

const UploadsPage: React.FC = () => {
  return <UploadFileTabPanel />;
};

export default UploadsPage;
